export interface UnidadeDTO {
    codigo: number;
    nome: string;
}

export interface EnderecoDTO {
    logradouro: string;
    numero: string;
    complemento: string;
    bairro: string;
    cep: string;
    tipoLogradouro: string;
    municipio: MunicipioDTO
}

export interface MunicipioDTO {
    codigo: string;
    nome: string;
    uf: string;
}

export interface ResponsavelPessoaJuridicaDTO {
    cpf: string;
    nome: string;
    situacaoCadastral: string;
    qualificacao: string;
}

export interface PrepostoPessoaJuridicaDTO {
    cpf: string;
    nome: string;    
}

export enum TipoContribuinte {
    CPFREQUERENTE = 'CpfRequerente',
    FILIALREQUERENTE = 'FilialRequerente',
    CNPJMATRIZ = 'CnpjMatriz',
    CNPJFILIALCENTRALIZADORA = 'CnpjFilialCentralizadora',
    CNPJMATRIZADQUIRIDA = 'CnpjMatrizAdquirida',
    CNPJFILIALADQUIRIDA = 'CnpjFilialAdquirida',
    CPFCANCELADOMULTIPLICIDADE = 'CpfCanceladoMultiplicidade',
} 

export interface NaturezaJuridicaDTO {
    codigo: string;
    numeroDv: string;
    nome: string;
}

export interface AtividadeEconomicaDTO {
    codigo: number;
    nome: string;
}

export interface OpcaoSimplesDTO {
    dataOpcao: Date;
    dataExclusao: Date;
}

export interface InfoCadastralPessoaJuridicaDTO {
    tipoContribuinte: TipoContribuinte;
    cnpj: string;
    cnpjAdquirente: string;
    codigoSituacaoCadastral: string;
    dataAbertura: Date;
    razaoSocial: string;
    codigoBaixa: string;
    motivoBaixa: string;
    dataBase: Date;
    situacaoCadastral: string;
    codigoPorteEmpresa: string;
    codigoQualificacaoTributaria: string;
    inAcompanhamentoDiferenciado: string;
    anoAcompanhamentoDiferenciado: number;
    anoInteresseDctf: string[];
    inOpcaoSimplesNacional: string;
    inOpcaoSimplesFederal: string;
    inOpcaoSimei: string;
    codigoEnteFederativoResponsavel: string;
    inFamiliaEnteFederativo: string;
    inCNPJAdquirente: number;
    unidade: UnidadeDTO;
    endereco: EnderecoDTO;
    responsavel: ResponsavelPessoaJuridicaDTO;
    preposto: PrepostoPessoaJuridicaDTO;
    naturezaJuridica: NaturezaJuridicaDTO;
    atividadeEconomica: AtividadeEconomicaDTO;
    simplesSN: OpcaoSimplesDTO[];
    simplesSF: OpcaoSimplesDTO[];
    simplesSimei: OpcaoSimplesDTO[];
}